export const hireReactBannerContentAr = {
    mainHeading: "وظّف مطوري React JS",
    content: "مصدر موثوق به لأفضل مطوري React JS عن بُعد، مثالي للشركات الناشئة والمؤسسات.",
    buttonText: "استشر مطوري React لدينا",
    bannerList: [
        { list: "متعاقدون مستقلون" },
        { list: "أدوار بدوام كامل" },
        { list: "فرق عالمية" },
    ]
};

export const hireReactServicesDataAr = {
    mainHeading: "خبرتنا في تطوير React",
    sectionDescription: "يتخصص مطورو React لدينا في إنشاء واجهات مستخدم سريعة وقابلة للتطوير وتفاعلية. نركز على تقديم أداء سلس وتوفير تجارب مستخدم استثنائية تجعل تطبيقك متميزًا.",
    buttonText: "حدد موعدًا لإجراء مكالمة اليوم",
    services: [
        {
            title: "استشارات React",
            description:
                "احصل على إرشادات الخبراء من مطورينا حول كيفية تحقيق أقصى استفادة من مشاريع React الخاصة بك. نساعدك على بناء أساس قوي وتعظيم إمكانات تطبيقك.",
            icon: "/images/hire-page-icons/hire-react-icons1.svg",
        },
        {
            title: "تطوير ويب React",
            description:
                "يتفوق فريقنا في تطوير تطبيقات ويب قابلة للتطوير وغنية بالميزات باستخدام React. نضمن أن يكون تطبيقك سهل الاستخدام، ومتجاوبًا، وسريعًا.",
            icon: "/images/hire-page-icons/hire-react-icons2.svg",
        },
        {
            title: "تطوير React API",
            description:
                "لدينا خبرة قوية في بناء واجهات برمجة تطبيقات (APIs) قوية باستخدام React. تساعد واجهات برمجة التطبيقات الخاصة بنا على ضمان اتصال سلس وسلس بين تطبيقات الويب الخاصة بك.",
            icon: "/images/hire-page-icons/hire-react-icons3.svg",
        },
        {
            title: "تطوير أنظمة إدارة المحتوى (CMS) والبوابات",
            description:
                "مطورونا ذوو خبرة في إنشاء أنظمة إدارة محتوى (CMS) قوية وبوابات ويب باستخدام React. نتأكد من أن نظامك سهل الاستخدام والإدارة.",
            icon: "/images/hire-page-icons/hire-react-icons4.svg",
        },
        {
            title: "الترحيل إلى React",
            description:
                "يمكن لخبرائنا مساعدتك في نقل أنظمتك الحالية إلى React دون عناء. نضمن ترحيلًا سلسًا بأقل وقت تعطل وانتقالات فعالة.",
            icon: "/images/hire-page-icons/hire-react-icons5.svg",
        },
        {
            title: "التكامل مع الحلول الحالية",
            description:
                "يمكننا دمج تطبيقات React الخاصة بك مع منصات وخدمات أخرى. سواء كان الأمر يتعلق بالاتصال بواجهات برمجة تطبيقات خارجية أو المزامنة مع الأدوات الموجودة، فقد قمنا بتغطيتك.",
            icon: "/images/hire-page-icons/hire-react-icons6.svg",
        },
        {
            title: "حلول التجارة الإلكترونية بـ React",
            description:
                "قم ببناء منصة التجارة الإلكترونية الخاصة بك باستخدام React. يتخصص مطورونا في إنشاء تجارب تسوق عبر الإنترنت سلسة وتفاعلية وسهلة الاستخدام تعزز عملك.",
            icon: "/images/hire-page-icons/hire-react-icons7.svg",
        },
        {
            title: "دعم وصيانة React",
            description:
                "ضمان النجاح المستمر لتطبيق React الخاص بك من خلال خدمات الدعم والصيانة المستمرة لدينا. نحافظ على تشغيل نظامك بسلاسة وكفاءة بمرور الوقت.",
            icon: "/images/hire-page-icons/hire-react-icons8.svg",
        },
    ],
};

export const hireReactSolutionsDataAr = {
    mainHeading: "لماذا تختار بيتسكلان لتوظيف",
    greenHeading: "مُطوري React",
    sectionDescription: "من خلال الجمع بين React وأحدث تقنيات الواجهة الأمامية والجوال، ننشئ حلولًا قوية وقابلة للتطوير ومصممة خصيصًا لتلبية احتياجات عملك. سواء كانت منصة ويب أو جوال، يضمن نهجنا أداءً سلسًا، وتطويرًا فعالًا، وتجارب مستخدم رائعة.",
    buttonText: "توظيف مطور اليوم",
    solutions: [
        {
            icon: "/images/hire-page-icons/chose-ror-section1.svg",
            title: "الوصول إلى المواهب المدققة",
            description:
                "التقِ بمطوري React لدينا، وجميعهم تم تدقيقهم بعناية لمهاراتهم وخبراتهم. كما أن لديهم مهارات تواصل قوية باللغة الإنجليزية، مما يجعل التعاون سهلاً وفعالاً.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section2.svg",
            title: "مشاهدة النتائج في ثوانٍ",
            description:
                "تجنب عناء مراجعة مئات السير الذاتية. باستخدام HireAI، يمكنك عرض ملفات تعريف مطوري React الذين هم على استعداد للعمل في مشروعك على الفور.",
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section3.svg",
            title: "وفّر مع التوظيف العالمي",
            description:
                "نمنحك الوصول إلى أكثر من 450,000 مطور من 190 دولة، مما يساعدك على توفير ما يصل إلى 58% مقارنة بأساليب التوظيف التقليدية.",
            noBorder: true,
        },
        {
            icon: "/images/hire-page-icons/chose-ror-section4.svg",
            title: "احصل على دعم بشري حقيقي",
            description:
                "اشعر بالثقة في قرارك بتوظيف مطوري React بمساعدة مباشرة من خبراء التوظيف لدينا. نحن نوجهك في كل خطوة على الطريق.",
        },
    ],
};

export const hireReactCombinationsAr = {
    heading: "أفضل تقنيات الدمج مع React.js لتطوير استثنائي",
    description:
        "استفد من قوة React.js مع أفضل تقنيات الدمج لبناء تطبيقات ويب ديناميكية وعالية الأداء وقابلة للتوسع. قم بتوظيف مطوري React.js الخبراء لإنشاء حلول تفاعلية وسلسة وجاهزة للمستقبل.",
    combinations: [
        {
            title: "ReactJS + Redux",
            description:
                "تكمل Redux مكتبة ReactJS من خلال مركزية إدارة بيانات التطبيق وتبسيط التعامل مع الحالة المعقدة. معًا، يوفران تطبيقات أمامية قابلة للتوسع وسهلة الصيانة. قم بتوظيف مطوري ReactJS لدمج مخصص بين React.js وRedux.",
            icons: ["react.svg", "redux.svg"],
        },
        {
            title: "ReactJS + TypeScript",
            description:
                "تعمل TypeScript، كنظام أنواع ثابت، على تحسين جودة الكود وتحسين الأدوات وكشف الأخطاء أثناء وقت الترجمة، مما يعزز كفاءة التطوير. قم بتوظيف خبراء ReactJS المتخصصين في تطوير ودمج وحدات TypeScript.",
            icons: ["react.svg", "typescript.svg"],
        },
        {
            title: "React + Node.js",
            description:
                "يمكن دمج React مع Node.js لتطبيقات JavaScript كاملة المكدس، مكونةً مكدس MERN أو MEAN، مما يوفر بيئة تطوير موحدة. يعمل مطورو ReactJS المتخصصون على إنشاء تطبيقات فريدة وديناميكية من خلال دمج React.js مع Node.js.",
            icons: ["react.svg", "nodejs.svg"],
        },
        {
            title: "React + GraphQL",
            description:
                "تعمل GraphQL، كلغة استعلام لواجهات برمجة التطبيقات، على تبسيط جلب البيانات عند دمجها مع React، مما يقلل من تحميل البيانات الزائد أو الناقص. تواصل مع مطوري ReactJS المهرة لدمج ReactJS بسلاسة في تطبيق الويب الخاص بك.",
            icons: ["react.svg", "graphql.svg"],
        },
        {
            title: "React + Next.js",
            description:
                "تُبسط Next.js، وهي إطار عمل شائع لـ React، العرض من جانب الخادم، والتوجيه، وتقسيم الكود لتطبيقات React محسّنة لمحركات البحث وعالية الأداء. تُعد خيارًا مثاليًا لمواقع React الثابتة والعرض من جانب الخادم والنشر بدون خوادم.",
            icons: ["react.svg", "next-js.svg"],
        },
        {
            title: "React + Java",
            description:
                "يجمع دمج ReactJS مع Java بين قوة مكتبة الواجهة الأمامية المتقدمة ولغة الخلفية متعددة الاستخدامات لإنشاء تطبيقات ويب حديثة. استفد من خبرات مطوري ReactJS لدمج React.js مع Java لتطبيقات مخصصة.",
            icons: ["react.svg", "java.svg"],
        },
    ],
};

export const hireReactStepsAr = {
    heading: "قم بتوظيف مطوري React JS في 4 خطوات سهلة",
    subHeading:
        "توظيف أفضل مطوري React أصبح سهلًا من خلال عملية مكونة من 4 خطوات بسيطة. نضمن لك تجربة سلسة وسريعة وفعالة لمطابقة المشروع مع المطور المثالي.",
    buttonText: "دعنا نجد المطور المثالي لك",
    steps: [
        {
            title: "اختر نموذج التعاون المناسب",
            description:
                "اختر نموذج التعاون الذي يناسب مشروعك سواء كنت بحاجة إلى التزام بدوام كامل أو جزئي أو بنظام الساعات.",
            icon: "/images/hire-page-setps-icons/icon-1.svg",
        },
        {
            title: "قم بفرز واختيار مطوري React",
            description:
                "تصفح ملفات تعريف أفضل مطوري React واختر من يتناسب مع متطلباتك.",
            icon: "/images/hire-page-setps-icons/icon-2.svg",
        },
        {
            title: "أجرِ مقابلة فردية",
            description:
                "قم بإجراء مقابلة مع المرشحين المختارين. اطرح أسئلة عملية ونظرية لتقييم مهاراتهم ومدى ملاءمتهم لمشروعك.",
            icon: "/images/hire-page-setps-icons/icon-3.svg",
        },
        {
            title: "بدء عمل مطور React",
            description:
                "بمجرد اتخاذ القرار، سيتم دمج مطور React الذي اخترته وسيكون جاهزًا للعمل خلال 24-48 ساعة.",
            icon: "/images/hire-page-setps-icons/icon-4.svg",
        },
    ],
};

export const hireReactCoverTheStackAr = {
    whereStart: "الأطر",
    mainHeading: "قم بتوظيف مطوري React الخبراء لحلول ويب تفاعلية وقابلة للتوسع",
    subHeading:
        "في Bitsclan، نعزز رحلة تطوير الويب الخاصة بك من خلال حزمة تقنيات React الحديثة التي تضمن تطبيقات ديناميكية وعالية الأداء وسهلة الاستخدام. يتخصص مطورونا المهرة في بناء تطبيقات ويب متجاوبة وغنية بالميزات وفقًا لاحتياجات عملك.",
    tabs: [
        "الأطر",
        "المكتبات",
        "الأدوات والمرافق",
        "قواعد البيانات",
        "أدوات إدارة المشاريع"
    ],
    tabItems: [
        // Frameworks
        { tab: "الأطر", icon: "/images/tech-stack-icons/next-js.svg", name: "Next.js" },
        { tab: "الأطر", icon: "/images/tech-stack-icons/gatsby.svg", name: "Gatsby" },
        { tab: "الأطر", icon: "/images/tech-stack-icons/remix.svg", name: "Remix" },

        // Libraries
        { tab: "المكتبات", icon: "/images/tech-stack-icons/react-query.png", name: "React Query" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/redux.svg", name: "Redux" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/react-hook-form.svg", name: "React Hook Form" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/framer-motion.svg", name: "Framer Motion" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/react.svg", name: "React Router" },
        { tab: "المكتبات", icon: "/images/tech-stack-icons/material-ui.svg", name: "Material UI" },

        // Tools & Utilities
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/webpack-icon.svg", name: "Webpack" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/babel.svg", name: "Babel" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/eslint.svg", name: "ESLint" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/prettier.svg", name: "Prettier" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/storybook.svg", name: "Storybook" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind CSS" },
        { tab: "الأدوات والمرافق", icon: "/images/tech-stack-icons/sass.svg", name: "SASS" },

        // Databases
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/mongodb.svg", name: "MongoDB" },
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/firebase.png", name: "Firebase" },
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/postgres.svg", name: "PostgreSQL" },
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/mysql-whale-icon.svg", name: "MySQL" },
        { tab: "قواعد البيانات", icon: "/images/tech-stack-icons/supabase.svg", name: "Supabase" },

        // Tools for PM
        { tab: "أدوات إدارة المشاريع", icon: "/images/tech-stack-icons/jira.svg", name: "Jira" },
        { tab: "أدوات إدارة المشاريع", icon: "/images/tech-stack-icons/trello.svg", name: "Trello" },
        { tab: "أدوات إدارة المشاريع", icon: "/images/tech-stack-icons/slack-icon.png", name: "Slack" },
        { tab: "أدوات إدارة المشاريع", icon: "/images/tech-stack-icons/zoom-icon.svg", name: "Zoom" },
        { tab: "أدوات إدارة المشاريع", icon: "/images/tech-stack-icons/google-meet.webp", name: "Google Meet" }
    ]
};

export const hireReactExpertFactsAr = {
    heading: "حقائق سريعة عن ",
    greenHeading: "فريق React لدينا",
    buttonText: "حجز موعد",
    facts: [
        {
            text: "<strong>مطورو React ذوو خبرة:</strong> يتمتع فريقنا بسنوات من الخبرة العملية في تطوير React JS، وإنشاء تطبيقات ويب ديناميكية وقابلة للتوسع.",
        },
        {
            text: "<strong>خبرة في نظام React البيئي:</strong> نحن متخصصون في إنشاء واجهات سريعة وسهلة الاستخدام باستخدام React ونظامه البيئي (مثل Redux وReact Router وغيرها).",
        },
        {
            text: "<strong>سجل حافل بالنجاح:</strong> أنجز مطورونا مشاريع React ناجحة في العديد من الصناعات، مما يضمن أداء عالي وسلاسة في الاستخدام.",
        },
        {
            text: "<strong>مهارات تكامل عالية:</strong> يتمتع مطورونا بخبرة في دمج تطبيقات React مع الخوادم الخلفية المختلفة وواجهات برمجة التطبيقات والخدمات الخارجية.",
        },
        {
            text: "<strong>تطوير متجاوب:</strong> نضمن أن تكون تطبيقات React الخاصة بك متجاوبة بالكامل وتعمل بسلاسة على جميع الأجهزة.",
        },
        {
            text: "<strong>دعم مخصص:</strong> يوفر فريقنا دعمًا وصيانة مستمرة لتطبيقات React لضمان بقائها محدثة وفعالة.",
        },
    ],
};

export const hireAppIdesContentAr = {
    heading: "لست متأكدًا من فكرة تطبيقك؟ أنجز نموذجك الأولي خلال ٦-٨ أسابيع!",
    sectionDescription: "هل لديك فكرة ولكنك غير متأكد من كيفية تنفيذها؟ يمكن لخبرائنا في جولانج مساعدتك في بناء نموذج أولي عملي خلال 6-8 أسابيع فقط! أثبت رؤيتك، واختبر تفاعل المستخدمين، وأرسِ أساسًا قويًا للنجاح مع خدمات التطوير الاحترافية لدينا."
}

export const hireReactPageEngagementModelsAr = {
    headingContent: [
        { text: "نماذج التعاقد" },
        { text: "المرنة لدينا" }
    ],
    discription:
        "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس وأقصى قدر من الكفاءة طوال مشروعك.",
    buttonText: "ابدأ الآن",
    hiringDetails: [
        {
            text: "التعاقد بالساعة",
            hours: "48",
            timeUnit: "ساعة",
            icon: "time.svg",
            bgColor: "#FDFDFF",
            durationLabel: "المدة", // Dynamic label
            duration: "8 ساعات/يوم",     // Dynamic value
            minimumDaysLabel: "الحد الأدنى للأيام", // Dynamic label
            minimumDays: "30 يومًا",           // Dynamic value
            billingLabel: "الفوترة",      // Dynamic label
            billing: "شهريًا",            // Dynamic value
            startWorkPhrase: "ابدأ العمل في غضون "
        },
        {
            text: "التعاقد بدوام كامل",
            hours: "72",
            timeUnit: "ساعة",
            icon: "full-time.svg",
            bgColor: "#FFFEFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "ابدأ في غضون "
        },
        {
            text: "التعاقد بدوام جزئي",
            hours: "48",
            timeUnit: "ساعة",
            icon: "part-time.svg",
            bgColor: "#FDFFFA",
            durationLabel: "المدة",
            duration: "8 ساعات/يوم",
            minimumDaysLabel: "الحد الأدنى للأيام",
            minimumDays: "30 يومًا",
            billingLabel: "الفوترة",
            billing: "شهريًا",
            startWorkPhrase: "انطلق في غضون "
        },
    ]
}

export const reactFaqContentAr = {
    mainHeading: "الأسئلة الشائعة",
    subHeading:
        "اكتشف خدمات تطوير React لدينا لتقديم حلول ويب مخصصة، وإنشاء واجهات برمجة التطبيقات، وإدارة النشر!",
    faqs: [
        {
            id: "collapseOne",
            question: "ما هو استخدام React JS؟",
            answer:
                "React JS هي مكتبة JavaScript شهيرة تُستخدم لبناء واجهات المستخدم لتطبيقات الويب. تساعد على إنشاء تطبيقات سريعة وتفاعلية وديناميكية، خاصة لتطبيقات الصفحة الواحدة (SPAs).",
        },
        {
            id: "collapseTwo",
            question: "لماذا يجب أن أوظف مطوري React لمشروعي؟",
            answer:
                "توظيف مطوري React يضمن حصولك على خبير قادر على بناء تطبيق ويب سريع وقابل للتوسع مع تجربة مستخدم رائعة. مرونة React وأداؤها يجعلها مثالية لتطبيقات الويب الحديثة.",
        },
        {
            id: "collapseThree",
            question: "هل يمكن استخدام React لتطبيقات الهاتف المحمول؟",
            answer:
                "نعم، يمكن استخدام React لتطبيقات الجوال من خلال React Native، مما يسمح بكتابة تطبيقات لكل من iOS وAndroid باستخدام نفس قاعدة الكود، مما يوفر وقت التطوير ويوفر تجربة متسقة.",
        },
        {
            id: "collapseFour",
            question: "كم من الوقت يستغرق بناء تطبيق React؟",
            answer:
                "يعتمد الوقت المطلوب لبناء تطبيق React على مدى تعقيد المشروع. قد تستغرق التطبيقات البسيطة بضعة أسابيع، بينما قد تستغرق التطبيقات المعقدة عدة أشهر. يعمل مطورونا بكفاءة للالتزام بالمواعيد النهائية.",
        },
        {
            id: "collapseFive",
            question: "هل يمكنني ترحيل تطبيقي الحالي إلى React؟",
            answer:
                "نعم، يتمتع مطورونا بخبرة في ترحيل تطبيقات الويب الحالية إلى React بسلاسة، مع الحفاظ على وظائف التطبيق دون أي خلل.",
        },
        {
            id: "collapseSix",
            question: "هل تقدمون خدمات دعم وصيانة لتطبيقات React؟",
            answer:
                "نعم، نحن نقدم خدمات دعم وصيانة مستمرة لتطبيقات React الخاصة بك. فريقنا متاح لإصلاح الأخطاء، وتحديث الميزات، وضمان تشغيل التطبيق بسلاسة.",
        },
    ],
};

export const mainBannerImgReactAr = {
    backgroundImage: `url(/images/hire-page-images/hire-react.avif)`,
    factBackgroundImage: `url(/images/hire-page-images/hire-react-arabic.avif)`,
};